module.exports = __webpack_public_path__ + "img/05.52c80ff7.png";